var _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchilderinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 0h39v39H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.711 18.983c.305-.436.6-.65.871-.084.302.633.165 1.79-.725 1.529-.201-.059-.825-.3-.823-.826.002-.594.489-.351.677-.619z",
    fill: "url(#schilder_inline_svg__schilder_inline_svg___Linear1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.011 9.218c0-.266-.105-.52-.292-.708a1.004 1.004 0 00-1.415 0 1.004 1.004 0 00-.293.708v22.565l2-.001V9.218z",
    fill: "none",
    strokeWidth: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.224 11.328c-.069-.477-2.739-1.242-3.902-1.03l-11.54 1.663c-.326.047-.534.472-.465.949l.249 1.727c.068.477.388.826.714.779l11.54-1.663c1.213-.175 3.521-1.613 3.453-2.09l-.049-.335zM26.41 20.78c-.002-.361-1.9-1.205-2.784-1.17l-5.131.019c-.247.001-.445.295-.444.655l.005 1.306c.001.36.202.652.448.65l5.131-.018c.917-.003 2.777-.828 2.776-1.188l-.001-.254z",
    fill: "#009ee0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.981,
    cy: 20.597,
    r: 3.727,
    fill: "url(#schilder_inline_svg__schilder_inline_svg___Linear2)",
    strokeWidth: 0.41,
    strokeLinecap: "butt",
    strokeMiterlimit: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "schilder_inline_svg__schilder_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-152 12.853 7.35) scale(1.72095)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005791",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ddf",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "schilder_inline_svg__schilder_inline_svg___Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(180 10.854 10.299) scale(7.4533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005792",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ee0",
    stopOpacity: 1
  })))));
}

export default SvgSchilderinline;